import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const PasswordReset = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await axios.post('/auth/password-reset', { email });
      if (response.data.success) {
        setSuccess(true);
      } else {
        setError(response.data.error || 'Erro ao redefinir senha.');
      }
    } catch (err) {
      const message = err.response?.data?.error || 'Erro ao conectar com o servidor. Tente novamente.';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="bg-animation" id="bgAnimation"></div>

      <div className="login-container">
        <div className="logo-container">
          <div className="logo">
            <img src="/logo.png?v=2" alt="Logo do Sistema" />
          </div>
          <h1>Recuperar Senha</h1>
          <p className="subtitle">
            {success 
              ? 'Verifique seu e-mail' 
              : 'Informe seu e-mail para receber uma nova senha'}
          </p>
        </div>

        {success ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{
              background: 'rgba(40, 167, 69, 0.1)',
              border: '1px solid rgba(40, 167, 69, 0.3)',
              borderRadius: '12px',
              padding: '20px',
              marginBottom: '20px'
            }}>
              <i className="fas fa-check-circle" style={{ fontSize: '40px', color: '#28a745', marginBottom: '12px', display: 'block' }}></i>
              <p style={{ color: '#28a745', fontWeight: 'bold', margin: '0 0 8px 0', fontSize: '16px' }}>
                Nova senha enviada!
              </p>
              <p style={{ color: '#666', margin: 0, fontSize: '14px' }}>
                Se o e-mail informado estiver cadastrado, você receberá uma nova senha em instantes.
              </p>
            </div>
            <Link 
              to="/login" 
              style={{
                display: 'inline-block',
                padding: '12px 30px',
                background: 'var(--color-accent, #c5a572)',
                color: '#fff',
                borderRadius: '8px',
                textDecoration: 'none',
                fontWeight: 'bold',
                fontSize: '15px'
              }}
            >
              <i className="fas fa-sign-in-alt" style={{ marginRight: '8px' }}></i>
              Voltar ao Login
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && (
              <div className="error-message">
                <i className="fas fa-exclamation-circle"></i>
                <span>{error}</span>
              </div>
            )}
            
            <div className="form-group">
              <label htmlFor="email">E-mail</label>
              <div className="input-container">
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={loading}
                  autoComplete="email"
                  placeholder="Seu e-mail cadastrado"
                />
                <i className="fas fa-envelope input-icon"></i>
              </div>
            </div>

            <button type="submit" className="login-btn" disabled={loading}>
              <i className="fas fa-paper-plane"></i>
              {loading ? 'Enviando...' : 'Enviar Nova Senha'}
            </button>
          </form>
        )}

        <div className="contact-link" style={{ marginTop: '16px' }}>
          <Link to="/login" style={{ color: 'var(--color-accent)', textDecoration: 'none', fontSize: '14px' }}>
            <i className="fas fa-arrow-left" style={{ marginRight: '6px' }}></i>
            Voltar ao Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PasswordReset;
